import { INFOBAR_HEIGHT } from '@/v2/constants'
import TabsMui from '@mui/material/Tabs'
import TabMui from '@mui/material/Tab'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.silver.main};
  padding: 38px 64px 60px 48px;
  height: calc(100% - ${INFOBAR_HEIGHT});
  overflow-y: auto;

  @media (max-width: 1024px) {
    padding: 16px;
    height: auto;
    min-height: 100%;
  }
`

export const Body = styled.div`
  background: ${({ theme }) => theme.white.main};
  border-radius: 3px;
  min-height: calc(100% - 100px);

  @media (max-width: 1024px) {
    min-height: auto;
  }
`

export const Header = styled.div`
  height: 60px;
  display: flex;
  align-items: end;
  padding-bottom: 4px;
  padding-left: 28px;
  border-bottom: 1px solid ${({ theme }) => theme.silver.dark};

  @media (max-width: 1024px) {
    height: auto;
    padding: 12px 16px;
    overflow-x: auto;
  }
`

export const Tabs = styled(TabsMui)`
  margin-right: 25px;
  display: inline-flex;

  & .MuiTabs-indicator {
    height: 3px;
  }

  @media (max-width: 1024px) {
    margin-right: 0;
  }
`
export const Tab = styled(TabMui)`
  && {
    padding: 2px;
    margin-right: 30px;
  }

  @media (max-width: 1024px) {
    && {
      margin-right: 16px;
      font-size: 13px;
      min-width: auto;
    }
  }
`
export const Content = styled.div`
  padding: 37px 28px;

  @media (max-width: 1024px) {
    padding: 16px;
  }
`

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin-top: 15px;
  border-radius: 4px;
  background: #f5f5f5;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 80%;

  @media (max-width: 1024px) {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
`

export const Value = styled.div`
  text-align: left;
  flex: 1;

  @media (max-width: 1024px) {
    padding: 8px 0;
  }
`

export const SmallValue = styled(Value)`
  flex: 0.5;

  @media (max-width: 1024px) {
    flex: 1;
    grid-column: span 2;
  }
`

export const ItemActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: space-between;
    border-top: 1px solid #e0e0e0;
    padding-top: 12px;
    margin-top: 4px;
  }
`

export const Icon = styled.div`
  width: 20px;
  margin: 0 auto;
  margin-top: 5px;
`
